import { schemaId } from 'cpool-schemas';
import { z } from 'zod';

export const CorporationsTableDefinitionZod = z.object({
    deactivated: z.boolean().default(false),
    directorId: schemaId.nullable(),
    id: schemaId,
    name: z.string().trim().min(1),
});

export type CorporationsTableSchema = z.infer<typeof CorporationsTableDefinitionZod>;
